import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('saintnicolas');

  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  return (
    <section className="relative min-h-[420px] md:min-h-[520px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A modern premium Quebec cottage house in Saint-Nicolas suburban neighborhood with architectural asphalt shingle roof and metal accents, contemporary 2010s architecture, large windows, manicured landscaping, warm golden hour light, professional real estate photography style, no people, clean aesthetic"
          alt="Toiture haut de gamme cottage moderne à Saint-Nicolas, Lévis par couvreur RBQ"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-10 pt-24 md:pt-32 pb-12">
        <div className="max-w-4xl mx-auto text-center">
          {/* Breadcrumb */}
          <nav className="mb-4 md:mb-6">
            <ol className="flex items-center justify-center gap-2 text-xs md:text-sm text-white/70">
              <li>
                <button
                  onClick={() => navigateTo('/')}
                  className="hover:text-copper transition-colors"
                >
                  {t('breadcrumb_home')}
                </button>
              </li>
              <li className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-white/50" />
              </li>
              <li>
                <span className="text-white/70">{t('breadcrumb_sectors')}</span>
              </li>
              <li className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-white/50" />
              </li>
              <li className="text-white font-medium">{t('breadcrumb_current')}</li>
            </ol>
          </nav>

          <h1 className="text-[40px] md:text-4xl lg:text-[52px] font-manrope font-bold text-white leading-tight mb-4 md:mb-5">
            {t('hero_h1')}
          </h1>

          <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
            {t('hero_subtitle')}
          </p>

          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5 mb-6 md:mb-8">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-center gap-2 text-white/80 text-sm md:text-base">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-check-line text-copper" />
                </span>
                {t(`hero_stat_${i}`)}
              </div>
            ))}
          </div>

          <button
            onClick={() => navigateTo('/soumission-gratuite')}
            className="inline-flex items-center gap-2 bg-copper hover:bg-copper-dark text-white font-semibold px-6 md:px-8 py-3 md:py-4 rounded-md text-sm md:text-base transition-all duration-300 whitespace-nowrap"
          >
            {t('hero_cta')}
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}